// extracted by mini-css-extract-plugin
export default {"container":"main_container__1beiN","inner":"main_inner__Ntdrd"};